'use client';

import { Box, SxProps } from '@mui/material';
import clsx from 'clsx';
import { usePathname } from '@/navigation';

export interface ActiveLinkProps {
  path: string;
  className?: string;
  sx?: SxProps;
  children?: React.ReactNode;
}

/**
 * Provides an active link class based on the current path.
 */
export function ActiveLink({ path, className, sx, children }: ActiveLinkProps) {
  const pathname = usePathname();

  return (
    <Box className={clsx(className, { active: pathname.startsWith(path) })} sx={sx}>
      {children}
    </Box>
  );
}
